import { css, polished } from 'jimu-core';
function getInputHeight(inputVarsBySize, inputBorderWidth) {
    const heightInner = polished.math(`
    ${inputVarsBySize.fontSize} * ${inputVarsBySize.lineHeight} +
    ${inputVarsBySize.paddingY} * 2`);
    return inputBorderWidth.toString() === '0'
        ? heightInner
        : `calc(${heightInner} + ${inputBorderWidth} * 2)`;
}
function getInputSizingStyles(inputVars, size) {
    const inputVarsBySize = inputVars.sizes[size];
    return `
    height: ${inputVarsBySize.height !== 'auto'
        ? inputVarsBySize.height
        : getInputHeight(inputVarsBySize, inputVars.border.width)};
    padding: ${inputVarsBySize.paddingY} ${inputVarsBySize.paddingX};
    font-size: ${inputVarsBySize.fontSize};
    line-height: ${inputVarsBySize.lineHeight};
    border-radius: ${inputVarsBySize.borderRadius};
  `;
}
export const advancedSelectStyles = (props) => {
    var _a, _b, _c;
    const size = props.bsSize || props.size || 'default';
    const theme = props.theme;
    const inputVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.input;
    const buttonProps = props === null || props === void 0 ? void 0 : props.buttonProps;
    return css `
    width: 100%;
    &.advanced-select-menu{
      max-width: 100vw;
      min-width: 200px;

      .output-warning-container{
        width: 240px;

        .output-warning-color{
          color: ${theme.sys.color.info.main};
        }
        .select-item{
          padding: 0.5rem 0;
          border-bottom: 1px solid ${theme.ref.palette.neutral[600]};

          &.active{
            color: inherit;
            background: inherit;
          }
          .select-item-placeholder{
            width: 1.25rem;
          }
        }
      }

      .search-container{
        padding: 0.25rem 0.5rem 0 0.5rem;
      }

      .list-container{
        max-height: 200px;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        overflow-y: auto;

        .no-data-label{
          text-align: left;
          margin: 0.25rem 0.5rem;
          font-style: italic;
          color: ${theme.ref.palette.neutral[1000]};
        }

        .jimu-dropdown-item{
          padding: 0.25rem 0.5rem;
          min-height: ${polished.rem(26)};
        }

        .select-item{
          &.multiple-item{
            padding-left: 0.5rem;
          }

          .select-item-placeholder{
            margin-right: 0.5rem;
            width: 0.75rem;
          }
        }

        .load-more-btn{
          padding-left: 0.5rem;
          padding-bottom: 0;
          border: none;
        }
      }

      .loading-container{
        position: relative;
        margin: 0.25rem 0.5rem;
        height: 20px;
        width: 20px;
      }

      .multiple-select-tool{
        margin: 0 0.5rem;
        padding: 0.25rem 0;
        display: flex;
      }
      .split-line {
        border-top: 1px solid ${theme.ref.palette.neutral[600]};
      }
    }

    ${(_b = ((buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.type) || (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.icon))) !== null && _b !== void 0 ? _b : css `
    /* Button overrides */
      > .dropdown{
        > .dropdown-button {
          &,
          &:hover {
            color: ${inputVars.color};
            background-color: ${inputVars.bg};
            background-clip: padding-box;
            box-shadow: ${inputVars.boxShadow};
            border-color: ${theme.sys.color.divider.input};
            transition: ${inputVars.transition};
            text-decoration: none;
            ${size === 'default' && getInputSizingStyles(inputVars, 'default')}
            ${size === 'sm' && getInputSizingStyles(inputVars, 'sm')}
            ${size === 'lg' && getInputSizingStyles(inputVars, 'lg')}
          }
          &[aria-expanded="true"] {
            border-color: ${theme.sys.color.action.selected.default};
          }
        }
      }
    `}

    ${(_c = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.type) !== null && _c !== void 0 ? _c : css `
    /* Button overrides */
      > .dropdown{
        > .dropdown-button {
          /* Placeholder */
          .placeholder {
            color: ${inputVars.placeHolderColor};
            opacity: 1;
          }

          /* Disabled and read-only inputs */
          &:disabled,
          &[readonly] {
            color: ${inputVars.disabled.color};
            background-color: ${inputVars.disabled.bg};
            opacity: 1;
          }
        }
      }
    `}
  `;
};
